export {
    getSourceAttribution,
    clearSourceAttribution,
    trackPreRegistrationPageVisit,
} from '../src/sourceAttribution';
